import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { ClockCounterClockwiseIcon, DotsThreeCircleVerticalIcon } from '@phosphor-icons/react'

import { ButtonMenu, IconButton } from '@reveni-io/reveni-ui'

import Title from './Title/Title'
import { getTabTitles } from './helpers'
import * as Styles from './styles'

const NestedRouteTitle = ({ tabSelected, tabs, onOpenHistory }) => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()

  const titles = getTabTitles(tabs, tabSelected, window.location.pathname, location?.state?.childPageTitle)

  const handleNavigate = tab => {
    if (location?.state?.previousLocation) {
      navigate(location?.state?.previousLocation)
    } else if (tab.children) {
      navigate(titles.page.path)
    } else {
      navigate(tab.path)
    }
  }

  if (!tabSelected) return null

  return (
    <Styles.TabContentTitle>
      {titles.parent && (
        <Title tab={titles.parent} isParent={titles.page || titles.childPage} onClick={handleNavigate} />
      )}
      {titles.page && <Title tab={titles.page} isParent={titles.childPage} onClick={handleNavigate} />}
      {titles.childPage && <Title tab={titles.childPage} />}
      {onOpenHistory && (
        <Styles.MenuContainer>
          <ButtonMenu
            menuItems={[
              {
                label: (
                  <Styles.MenuOptionLabel>
                    <ClockCounterClockwiseIcon size={16} />
                    {t('Historial de la página')}
                  </Styles.MenuOptionLabel>
                ),
                onClick: onOpenHistory,
              },
            ]}
            renderButton={onOpen => (
              <IconButton
                onClick={onOpen}
                variant="text"
                icon={<DotsThreeCircleVerticalIcon data-testid="history-menu-button" size={24} weight="light" />}
              />
            )}
          />
        </Styles.MenuContainer>
      )}
    </Styles.TabContentTitle>
  )
}

export default NestedRouteTitle
